import { render, staticRenderFns } from "./BoxLine.vue?vue&type=template&id=12587322&scoped=true&"
import script from "./BoxLine.vue?vue&type=script&lang=js&"
export * from "./BoxLine.vue?vue&type=script&lang=js&"
import style0 from "./BoxLine.vue?vue&type=style&index=0&id=12587322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12587322",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12587322')) {
      api.createRecord('12587322', component.options)
    } else {
      api.reload('12587322', component.options)
    }
    module.hot.accept("./BoxLine.vue?vue&type=template&id=12587322&scoped=true&", function () {
      api.rerender('12587322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/erp/pay-box-close/components/BoxLine.vue"
export default component.exports